/**
 * price-finder.js — bộ chọn khoảng giá ở trang chủ (mục "Theo khoảng giá").
 *
 * Markup: [data-price-finder] chứa
 *         input[data-price-range] (range 0..n−1, mỗi nấc một khoảng giá; số nấc = số bảng),
 *         [data-price-stop="k"] nhãn mốc giá (bấm = nhảy tới nấc k),
 *         [data-price-panel="k"] bảng của khoảng giá k.
 * Dùng <input type="range"> thật (không tự vẽ núm kéo) để bàn phím, đọc màn hình và kéo cảm ứng
 * chạy sẵn; aria-valuetext đọc tên khoảng giá thay vì số thứ tự nấc.
 * Chưa có JS thì không bảng nào bị ẩn — mọi bảng xếp dọc, nút vẫn dẫn tới PLP lọc giá.
 * Tô phần đã chọn của thanh qua biến --p (0 → 1) vì ::-webkit-slider-runnable-track không có
 * pseudo kiểu ::-moz-range-progress.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var root = document.querySelector('[data-price-finder]');
    if (!root) return;

    var range = root.querySelector('[data-price-range]');
    var stops = [].slice.call(root.querySelectorAll('[data-price-stop]'));
    var panels = [].slice.call(root.querySelectorAll('[data-price-panel]'));
    if (!range || !panels.length) return;

    var last = -1;

    function label(panel) {
        var l = panel.querySelector('.price-finder__label');
        var v = panel.querySelector('.price-finder__value');
        return (l ? l.textContent : '') + ' ' + (v ? v.textContent : '');
    }

    function show(index, track) {
        index = Math.max(0, Math.min(panels.length - 1, index));
        if (index === last) return;
        last = index;

        range.value = index;
        root.style.setProperty('--p', String(index / (panels.length - 1)));
        range.setAttribute('aria-valuetext', label(panels[index]));

        panels.forEach(function (panel, i) {
            panel.hidden = i !== index;
        });
        stops.forEach(function (stop, i) {
            stop.classList.toggle('is-active', i === index);
        });

        if (track && window.WBTrack) {
            window.WBTrack('price_slider_change', { label: panels[index].querySelector('[data-track-label]').getAttribute('data-track-label') });
        }
    }

    range.addEventListener('input', function () {
        show(parseInt(range.value, 10), true);
    });

    stops.forEach(function (stop) {
        stop.addEventListener('click', function () {
            show(parseInt(stop.getAttribute('data-price-stop'), 10), true);
        });
    });

    // Mở trang ở nấc 500K – 1tr: khoảng giá được tìm nhiều nhất, không bắt đầu ở đầu mút
    show(range.value === '' ? 1 : parseInt(range.getAttribute('value') || '1', 10), false);
})();
